import { edit_tname_click, edit_tdesc_click, close_edit_tname, close_edit_tdesc} from './page-scripts/myTrips_scripts';
import { handleSharePopup } from './util/general_util';
import { send_delete_trip, set_savedTrip_description, set_savedTrip_name } from './util/user_api';
import { send_copyTrip } from './util/user_api';

if (window.location.pathname === "/myTrips") {

	// $(document).on("click", ".dropdown-menu .nestedDropdown", function(e){
	// 	e.stopPropagation();
	// });
	document.querySelectorAll('.nestedDropdown .nestedDropdown-item').forEach(function(element) {
		element.addEventListener('click', function(e) {
		  e.stopPropagation();
		});
	  });

	$("#copyTripModal").on("shown.bs.modal", () => {
		$("#copyTripModal").find("#tripName").select();
	});

	$("#copyTrip").on("submit", function(event) {
		event?.preventDefault();
		let name:string = $("#copyTripModal").find("#tripName").val() as string;
		let ownTrip:boolean = true;
		let copyStays:boolean = $("#copyStays").prop("checked");
		let copyNotes:boolean = $("#copyNotes").prop("checked");
		let tripID:string = $(this).attr("tripID");
		send_copyTrip(tripID, name, ownTrip, copyStays, copyNotes).then(() => {
			window.location.reload();
		}).catch(e => {
			const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
			$("#errorModal").modal("show");
		});
	});

	$(document).on("click", "[copyTripBtn]", function() {
		let tripID:string = $(this).attr("tripID") as string;
		let parentWrapper:JQuery<HTMLElement> = $(`.tripCardWrap[id='${tripID}']`);
		let tripName:string = parentWrapper.find(".card-title").html() as string;
		$("#copyTripModal").find("#tripName").val(`Copy of: ${tripName}`);
		$("form#copyTrip").attr("tripID",tripID);
		$("#copyTripModal").modal("show");
	});



	$(document).on("click", "[tripPrivacyBtn]", handleSharePopup);

	$(".edit-tname").on("click", function(this: any,event: JQuery.ClickEvent<any, any, any, any>){edit_tname_click(this,event)});
	$(".edit-tdesc").on("click", function(this: any,event: JQuery.ClickEvent<any, any, any, any>){edit_tdesc_click(this,event)});
	$(".editTnameForm").on("submit", function(this: any,event: { preventDefault: () => void; }) {

		event.preventDefault();
		let tripName:string = $(this).find("input").val() as string;
		let tripID:string = $(this).attr("tripID");
		let $tripNameEl:JQuery<HTMLElement> = $(this).parentsUntil(".card").parent().find(".tname");
		let $formEl:JQuery<HTMLFormElement> = $(this) as JQuery<HTMLFormElement>;

		set_savedTrip_name(tripID, tripName).then(() => {
			$formEl.hide();
			$formEl.removeClass("d-flex");
			$tripNameEl.addClass("d-flex");
			$(`.tripCardWrap#${tripID}`).find("[tripName]").html(tripName);
			$tripNameEl.show();
		}).catch(e => {
			const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
			$("#errorModal").modal("show");
		});
	});
	$(".editTdescForm").on("submit", function(this: any,event: { preventDefault: () => void; }) {
		event.preventDefault();
		let tripDesc:string = $(this).find("[contenteditable='true']").html().trim();
		let tripID:string = $(this).attr("tripID");
		let $tripDescEl:JQuery<HTMLElement> = $(this).parentsUntil(".card").parent().find(".tdesc");
		let $formEl:JQuery<HTMLFormElement> = $(this) as JQuery<HTMLFormElement>;
		set_savedTrip_description(tripID, tripDesc).then(() => {
			$formEl.hide();
			$formEl.removeClass("d-flex");
			$tripDescEl.addClass("d-flex");
			$tripDescEl.find("h6").html(tripDesc);
			$tripDescEl.show();
		}).catch(e => {
			const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
			$("#errorModal").modal("show");
		});
	});

	$("[closeSetName]").on("click", function(this:HTMLElement){close_edit_tname(this)});
	$("[closeSetDesc]").on("click", function(this:HTMLElement){close_edit_tdesc(this)});

	$(document).on("click", "#delTrip_init", function() {
		let tripID:string = $(this).attr("tripID") as string;
		let parentWrapper:JQuery<HTMLElement> = $(`.tripCardWrap[id='${tripID}']`);
		let tripName:string = parentWrapper.find(".card-title").html() as string + "?";
		$("#delTrip").attr("tripID",tripID);
		$("#delTrip_tripName").html(tripName);
		$("#deleteTripModal").modal("show");
	});

	$(document).on("click", "#delTrip", function() {
		let tripID:string = $(this).attr("tripID") as string;
		send_delete_trip(tripID).then(() => {
			$(`.tripCardWrap[id='${tripID}']`).remove();
		}).catch(e => {
			const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
			$("#errorModal").modal("show");
		});
	});

	$(document).ready(function() {
		//Convert last time trip was edited from UTC to user's timezone
		$("[tripEditTime]").each(function(this) {
			let splitdate:string[] = $(this).text().toString().split(":");
			let prefix = splitdate[0];
			let timestamp:string = "";

			for (let i:number = 1; i < splitdate.length; i++) {
				timestamp += splitdate[i] + ":"
			};

			//Convert timestamp from YYYY-mm-dd:HH:MM to YYYY-mm-ddTHH:MM:SSZ for typescript Date object
			let timestamp_with_seconds = timestamp.replace(":","T") + "00Z";

			const date = new Date(timestamp_with_seconds.replace(/\s/g,""));
			const userTimezone = date.toLocaleString('en-US',{
				year:'numeric',
				month: 'short',
				day:'numeric',
				hour:'2-digit',
				minute:'2-digit'
			});
			$(this).text(`Last Edited: ${userTimezone}`);
		});
	});
};